import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// import { Gold } from './main/main.component';
import { GoldFinchChatPage } from './gold-finch-chat.page';
import { ChatService } from '../core/services/chat.service';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../shared/shared.module';
import { GoldFinchChatRoutingModule } from './gold-finch-chat-routing.module';
import { ScrollingModule } from '@angular/cdk/scrolling'
import { ScrollDispatcher } from '@angular/cdk/scrolling';;
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatChipsModule } from '@angular/material/chips';
import { ClipboardButtonComponent, ClipboardOptions, MarkdownModule, MarkedOptions } from 'ngx-markdown';

import 'prismjs';
import 'prismjs/components/prism-typescript.min.js';
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';
import 'prismjs/plugins/line-highlight/prism-line-highlight.js';

// import {
//   PerfectScrollbarModule,
//   PerfectScrollbarConfigInterface,
//   PERFECT_SCROLLBAR_CONFIG,
// } from 'ngx-perfect-scrollbar';
// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   wheelPropagation: true,
// };

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GoldFinchChatRoutingModule,
    IonicModule,
    SharedModule,
    ScrollingModule,
    MatSidenavModule,
    MatChipsModule,
    MarkdownModule.forRoot({
      clipboardOptions: {
        provide: ClipboardOptions,
        useValue: {
          buttonComponent: ClipboardButtonComponent
        },
      },
    }),
  ],
  declarations: [GoldFinchChatPage],
  providers: [ChatService, ScrollDispatcher],
})
export class GoldFinchChatModule {}